import {MuiPickersOverrides} from '@material-ui/pickers/typings/overrides';
import {Theme} from '@material-ui/core';

export const createMuiPickersMonthOverrides = ({
    palette,
    spacing
}: Theme): MuiPickersOverrides['MuiPickersMonth'] => ({
    root: {
        justifyContent: 'flex-start',
        color: palette.text.secondary,
        minHeight: spacing(8),
        maxHeight: spacing(8),
        padding: spacing(0, 4),
        fontSize: '14px'
    },
    monthSelected: {
        color: palette.text.primary,
        backgroundColor: palette.action.selected
    },
    monthDisabled: {
        opacity: 0.3,
        color: palette.action.focus
    }
});
